<template>
  <div>
    <AuthHeading
      title="Log in to Eventor.app"
      sub-title="Create events, import guest lists and check guests in from any device."
    />
    <AuthForm is-sign-in />
  </div>
</template>

<script>
import AuthHeading from '@/components/auth/AuthHeading';
import AuthForm from '@/components/auth/AuthForm';

export default {
  components: {
    AuthHeading,
    AuthForm,
  },
};
</script>

<style scoped>
</style>
